import { interfaces } from "inversify";
import { environmentConfigRTTI, EnvironmentConfig } from "~/modules/config";

export function getTwilioIdpUrl(container: interfaces.Container, port?: string): string {
    const envConfig = container.get<EnvironmentConfig>(environmentConfigRTTI);

    const twilioServiceLoginUrl = envConfig.twilioServiceLoginUrl;
    return port ? `${twilioServiceLoginUrl}?localPort=${port}` : twilioServiceLoginUrl;
}
